// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__19tcs","select":"Header_select__rX0gN","clinic":"Header_clinic__1moUT"};